import { Injectable } from '@angular/core';
import { IViewOnlyQuestion } from 'shared-components';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
  })
export class QuestionTextService {
  private questionTextUpdated$ = new Subject<IViewOnlyQuestion>();

  public updateQuestionText(question: IViewOnlyQuestion): void {
    this.questionTextUpdated$.next(question);
  }

  public questionTextUpdated(): Observable<IViewOnlyQuestion> {
    return this.questionTextUpdated$.asObservable();
  }
}
